import React from 'react';

const PlusIcon = () => (
  <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8792 8.97616H12.6792V2.01616C12.6792 0.995356 11.9232 0.160156 10.9992 0.160156C10.0752 0.160156 9.31922 0.995356 9.31922 2.01616V8.97616H2.11922C1.06322 8.97616 0.199219 9.70696 0.199219 10.6002C0.199219 11.4934 1.06322 12.2242 2.11922 12.2242H9.31922V19.1842C9.31922 20.205 10.0752 21.0402 10.9992 21.0402C11.9232 21.0402 12.6792 20.205 12.6792 19.1842V12.2242H19.8792C20.9352 12.2242 21.7992 11.4934 21.7992 10.6002C21.7992 9.70696 20.9352 8.97616 19.8792 8.97616Z" />
  </svg>
);

export default PlusIcon;
